module.exports = __webpack_public_path__ + "media/images/icons/flags/GM-01c11145b300f46aca3b044ec282fdb0.svg";